<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      短信充值
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
          :class="{'search-detail-close': !searchVisible}"
          :style="{overflow: !searchVisible ? 'hidden' : ''}"
        >
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入企业名称"
          v-model="searchForm.ep_name"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入corpID"
          v-model="searchForm.corpid"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入充值人名称"
          v-model="searchForm.create_user_name"
          ></Input>
        </div>
        <div class="search-detail-item">
          <DateRangePicker
            class="search-input"
            placement="bottom-end"
            :placeholder="'充值时间'"
            :value="emptyDate"
            @on-change="daterangeChange($event, 'create_start_time', 'create_end_time')"
          />
        </div>
        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="pageIndex=0,loadList()"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm"
          >重置</Button>
        </div>
        </div>
      </div>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
  </Card>
 </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker
  },
  data () {
    return {
      emptyDate: ['', ''],
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        corpid: '', // 企业corpid
        ep_name: '', // 企业名称
        create_user_name: '', // 充值人名称
        create_start_time: '', // 充值开始时间
        create_end_time: '' // 充值结束时间
      }
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '企业ID',
          key: 'ep_id',
          width: 140
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 200
          // render: (h, { row }) => {
          //   return h(
          //     'Tooltip',
          //     {
          //       props: {
          //         placement: 'top',
          //         content: row.corpid,
          //         'max-width': 250
          //       }
          //     },
          //     [
          //       h(
          //         'div',
          //         {
          //           class: 'ivu-table-cell-ellipsis',
          //           style: { maxWidth: '180px' }
          //         },
          //         row.corpid
          //       )
          //     ]
          //   )
          // }
        },
        {
          title: '短信条数',
          key: 'num',
          width: 140
        },
        {
          title: '充值金额',
          key: 'amount',
          width: 180
        },
        {
          title: '充值人',
          key: 'create_user_name',
          width: 140
        },
        {
          title: '充值时间',
          key: 'createtime',
          width: 180
        },
        {
          title: '充备注',
          key: 'remark',
          width: 300
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  watch: {
    chouseState (val) {
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/enterprise/smsRechargeLog/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        }),

        this.$http.get('/enterprise/smsRechargeLog/count', {
          params: this.searchForm
        })
      ]).then(this.$http.spread((res1, res2, res3) => {
        if (res1.success && res2.success) {
          this.list = res1.data
          this.count = res2.data
          this.listLoading = false
        }
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyDate = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm () {
      this.chouseState = ''
      this.emptyDate = ['', '']
      this.searchForm = {
        corpid: '', // 企业corpid
        ep_name: '', // 企业名称
        create_user_name: '', // 充值人名称
        create_start_time: '', // 充值开始时间
        create_end_time: '', // 充值结束时间
      }
      this.loadList()
    }
  },
  created () {
    this.$http.get('/dropdown/industry').then(res => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.buyPeople = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 20px;
  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 95px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/pages/recharge/rechargeLog/index.vue